import { HiOutlineMail } from "react-icons/hi";
import { BiMessageRounded } from "react-icons/bi";
import { FiMapPin } from "react-icons/fi";
import { TbPhone } from "react-icons/tb";

export const mapsData = [
  {
    title: "Support",
    text: "Our friendly team is here to help",
    email: "support@knoct.in",
  },
  {
    title: "Sales",
    text: "Questions or queries? Get in touch",
    email: "sales@knoct.in",
  },
  {
    title: "Phone",
    text: "Mon-Fri from 8am to 5pm.",
    email: "+91(125)000-0000 ",
  },
];
export const contactsData = [
  {
    icon: HiOutlineMail,
    title: "Email us",
    text: "Email Us directly",
    email: "sales@knoct.in",
  },
  {
    icon: BiMessageRounded,
    title: "Chat to support",
    text: "We're here to help",
    email: "support@knoct.in",
  },
  {
    icon: FiMapPin,
    title: "Visit us",
    text: "Visit our office HQ.",
    email: "Banglore, India ",
  },
  {
    icon: TbPhone,
    title: "Call us",
    text: "Mon-Fri from 8am to 5pm.",
    email: "+91(125)000-0000 ",
  },
];
